import React, { Fragment } from 'react';
import { Col, Container, Image, ListGroup, Row } from 'react-bootstrap';
import "./ClientLogoScroll.scss";
import Slider from 'react-slick';

const ClientLogoScroll = ({ ClientLogo, logoSlider, arrows, show, hide , count1, count2, count3, count4, count5 }) => {
       const settings = {
        className: "slider variable-width",
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: count1,
        slidesToScroll: 1,
        arrows: arrows,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
              breakpoint: 992,
              settings: {
              slidesToShow: count2
              }
            },
            {
              breakpoint: 768,
              settings: {
              slidesToShow: count3
              }
            },
            {
              breakpoint: 480,
              settings: {
              slidesToShow: count4
              }
            },
            {
              breakpoint: 320,
              settings: {
              slidesToShow: count5
              }
            }
          ]
        };

    return (
        <>
            <div className={logoSlider}>
                <Container>
                    {ClientLogo.map((clientList, clientIndex) => (
                        <Fragment key={clientIndex}> 

                          {clientList.isHeadHide === show && (
                            <Row className="justify-content-center align-items-center mb-3 text-center">
                                <Col lg={12} xl={12} xxl={12}>
                                    <h2 className="mb-2">{clientList.title}</h2>
                                    <p className="fn-3">{clientList.desc}</p>
                                </Col>
                            </Row>
                            )}

                            {clientList.isHeadHide === hide && (
                            <Row className="justify-content-center align-items-center">
                                <Col lg={8} xl={7} xxl={6}>
                                <ListGroup horizontal className="heading-mid-top">
                                    <ListGroup.Item>
                                    <h2 className="text-center text-black fn-7 mb-0">
                                        <span
                                        dangerouslySetInnerHTML={{
                                            __html: clientList.headingHr.replaceAll("className='", "class='"),
                                        }}
                                        />
                                    </h2>
                                    </ListGroup.Item>
                                </ListGroup>
                                </Col>
                            </Row>
                            )}
                                
                           

                            <Slider {...settings}>
                                {clientList.CustomersList.map( (list, Index) => 
                                <div key={Index}>
                                    <Image src={list.imgUrl} alt={list.alt} />
                                </div> 
                                )}
                            </Slider>
                        </Fragment>
                    ))}
                </Container>
            </div>
        </>
    )
}

export default ClientLogoScroll;